import { Operation } from "@forgepoint/shared";
import { operationSourceLabel } from "@/components/operationSelector/operationLabels";
import { formatAbsoluteTimestamp, formatCompactAge } from "@/lib/relativeTime";

interface OperationRowMetaProps {
  /** The operation whose source type and freshness are displayed. */
  operation: Operation;
}

/**
 * Renders an operation's source type and how recently it was updated.
 * @param props - The operation to describe
 * @returns The secondary line for an operation selector row
 */
export function OperationRowMeta({ operation }: OperationRowMetaProps) {
  return (
    <span>
      {operationSourceLabel(operation)} · updated{" "}
      <span title={formatAbsoluteTimestamp(operation.updatedAt)}>
        {formatCompactAge(operation.updatedAt)}
      </span>
    </span>
  );
}
